import React from "react";
import { Col, Row } from "react-bootstrap";
import { AiFillAndroid, AiFillApple } from "react-icons/ai";
import { FaAws, FaGoogle } from "react-icons/fa";
import {
  GrGithub,
  GrGraphQl,
  GrMysql,
  GrNode,
  GrReactjs,
} from "react-icons/gr";
import { PiFileSql } from "react-icons/pi";
import {
  SiAgora,
  SiFirebase,
  SiGooglemaps,
  SiMongodb,
  SiRedux,
  SiSocketdotio,
  SiStripe,
  SiWebrtc,
} from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";

import { CgBitbucket, CgMore, CgTwilio } from "react-icons/cg";
import TeamCard from "../Cards/TeamCard";
import TitleHeader from "../Header/TitleHeader";

const SectionD = ({ id, onClick }) => {
  return (
    <section id="tab_4" onClick={onClick}>
      <div className="container__services">
        <TitleHeader title={"Technologies"} />
        <Row>
          {[
            {
              icon: <GrReactjs size={80} className="techIcon" />,
              title: "React",
            },
            {
              icon: <TbBrandNextjs size={80} className="techIcon" />,
              title: "Next",
            },
            {
              icon: <GrReactjs size={80} className="techIcon" />,
              title: "React Native",
            },
            {
              icon: <AiFillApple size={80} className="techIcon" />,
              title: "IOS",
            },
            {
              icon: <AiFillAndroid size={80} className="techIcon" />,
              title: "Android",
            },

            {
              icon: <SiFirebase size={80} className="techIcon" />,
              title: "Firebase",
            },

            {
              icon: <CgTwilio size={80} className="techIcon" />,
              title: "Twillio",
            },
            {
              icon: <SiAgora size={80} className="techIcon" />,
              title: "Agora",
            },

            {
              icon: <SiWebrtc size={80} className="techIcon" />,
              title: "Web Rtc",
            },
            {
              icon: <SiSocketdotio size={80} className="techIcon" />,
              title: "Websocket",
            },

            {
              icon: <SiSocketdotio size={80} className="techIcon" />,
              title: "Websocket",
            },

            {
              icon: <GrGraphQl size={80} className="techIcon" />,
              title: "GraphQL",
            },

            {
              icon: <SiRedux size={80} className="techIcon" />,
              title: "Redux",
            },

            {
              icon: <SiStripe size={80} className="techIcon" />,
              title: "Stripe",
            },
            {
              icon: <GrNode size={80} className="techIcon" />,
              title: "Node",
            },
            {
              icon: <SiMongodb size={80} className="techIcon" />,
              title: "MongoDB",
            },
            {
              icon: <GrMysql size={80} className="techIcon" />,
              title: "MySQL",
            },
            {
              icon: <PiFileSql size={80} className="techIcon" />,
              title: "SQL Server",
            },
            {
              icon: <SiGooglemaps size={80} className="techIcon" />,
              title: "Maps",
            },

            {
              icon: <FaAws size={80} className="techIcon" />,
              title: "AWS",
            },
            {
              icon: <FaGoogle size={80} className="techIcon" />,
              title: "GCP",
            },
            {
              icon: <GrGithub size={80} className="techIcon" />,
              title: "GitHub",
            },
            {
              icon: <CgBitbucket size={80} className="techIcon" />,
              title: "BitBucket",
            },
            {
              icon: <CgMore size={80} className="techIcon" />,
              title: "20+ Skills",
            },
          ].map((item) => {
            return (
              <Col md={3} lg={2} sm={12} className="serviceCard">
                <TeamCard icon={item.icon} title={item.title} />
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
};
export default SectionD;
